exports.components = {
  "component---node-modules-bufox-gatsby-theme-parkio-src-pages-404-js": () => import("./../../../node_modules/@bufox/gatsby-theme-parkio/src/pages/404.js" /* webpackChunkName: "component---node-modules-bufox-gatsby-theme-parkio-src-pages-404-js" */),
  "component---node-modules-bufox-gatsby-theme-parkio-src-pages-index-js": () => import("./../../../node_modules/@bufox/gatsby-theme-parkio/src/pages/index.js" /* webpackChunkName: "component---node-modules-bufox-gatsby-theme-parkio-src-pages-index-js" */)
}

